module.exports = __webpack_public_path__ + "static/media/inventory.ef2c2cc8.svg";